import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getControlTokens } from './controlTokens';

function ControlAutocomplete({
  context = 'filterBar',
  placeholder = 'Select...',
  minWidth,
  sx,
  renderInput,
  ...props
}) {
  const theme = useTheme();
  const tokens = getControlTokens(theme, context);

  return (
    <Autocomplete
      size="small"
      sx={{
        minWidth,
        width: '100%',
        '& .MuiOutlinedInput-root': {
          height: tokens.height,
          backgroundColor: tokens.surface,
          border: `1px solid ${tokens.borderColor}`,
          fontSize: tokens.fontSize,
          '& fieldset': { border: 'none' },
        },
        '& .MuiOutlinedInput-input': {
          padding: `${context === 'objectToolbar' ? 3 : 6}px 8px !important`,
          fontSize: tokens.fontSize,
          color: theme.palette.text.secondary,
        },
        ...sx,
      }}
      renderInput={(params) => (
        renderInput ? renderInput(params, tokens) : (
          <TextField {...params} placeholder={placeholder} />
        )
      )}
      {...props}
    />
  );
}

export default ControlAutocomplete;
